import { observer } from "mobx-react-lite";
import * as React from "react";
import { DrawerPlmWithConfirmation } from "src/components/DrawerPlmWithConfirmation";
import { multiStepOnRowClick } from "src/components/MultiStepTask/utils";
import { EntityFiltersPageStore } from "src/pages/EntityFiltersPage/EntityFiltersPageStore";
import { EntityFiltersTable } from "src/pages/EntityFiltersPage/EntityFiltersTable";
import { ZEntityRow } from "src/pages/EntityFiltersPage/EntityList/types";
import { onError } from "src/common/onError";
import { ZPlanning2Settings } from "../ZPlanning2Settings";

type PropsPlanning2NewTemplate = {
  open: boolean;
  close: () => void;
  settings: ZPlanning2Settings;
  success: (selected: ZEntityRow) => void; // без закрывания
};

export const Planning2NewTemplate: React.FC<PropsPlanning2NewTemplate> =
  observer((props) => {
    const { open, close, success, settings } = props;
    const [store, setStore] = React.useState<EntityFiltersPageStore | null>(
      null,
    );
    const tableStore = store?.tableStore;
    const selected = tableStore?.selected?.[0];
    const { templateObjectId } = settings;
    const title = "Шаблон задач";
    React.useEffect(() => {
      if (open) {
        if (!templateObjectId) {
          onError(Error("Не указан объект шаблона"));
          close();
        } else {
          const onRowClick = (clickedRow: ZEntityRow) => {
            multiStepOnRowClick(clickedRow, entityStore);
          };
          const entityStore = new EntityFiltersPageStore({
            objectId: templateObjectId,
            selectionSettings: { selectionType: "radio" },
            onRowClick,
            actions: new Set(), // Чтобы не было кнопки создания модели, т.к. она вызывает переход на другую страницу.
            title,
          });
          setStore(entityStore);
        }
      } else {
        setStore(null);
      }
    }, [open]);
    return (
      <DrawerPlmWithConfirmation
        drawerProps={{
          title,
          open,
          onClose: close,
          width: "75vw",
        }}
        confirmationProps={{
          okText: "Выбрать",
          okButtonProps: {
            disabled: !selected,
            onClick: () => {
              if (selected) {
                success(selected);
                close();
              }
            },
          },
          cancelButtonProps: {
            onClick: close,
          },
        }}
      >
        {store && <EntityFiltersTable store={store} />}
      </DrawerPlmWithConfirmation>
    );
  });
